/** Opt-in diagnose in de eigen browser; nooit codes, identiteiten of tokens. */
export function traceAuthTransition(phase: string, state: {
  event?: string;
  authenticated?: boolean;
  aal?: "aal1" | "aal2" | "unknown";
  decision?: string;
  destination?: "/login" | "/2fa" | "/app" | "/app/activatiecentrum";
} = {}): void {
  try {
    if (typeof window === "undefined" || window.sessionStorage.getItem("collectr-auth-trace") !== "1") return;
    console.debug("[collectr-auth]", { timeMs: Math.round(performance.now()), phase, ...state });
  } catch {
    // Diagnostiek verandert het authpad niet als sessionStorage geblokkeerd is.
  }
}
